module.exports = __webpack_public_path__ + "assets/caf95dcb364b2bbe631c7a235991afab.mp4";